import "./styles.css";
import { useEffect, useState } from "react";

import { Sidebar } from "./components/Sidebar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Products } from "./components/Products";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

// import { Hero } from './components/Hero';
import { Navbar } from "./components/Navbar";
import { DeliveryTypes } from "./components/DeliveryTypes";
import { ServiceTypes } from "./components/ServiceTypes";
import { Expertise } from "./components/Expertise";

export default function App() {
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    document.title = "Ethos Tech Hub Limited";
  }, []);

  return (
    <div className={`bg-gray-100 min-h-screen ${darkMode ? "dark" : ""}`}>
      <Navbar />
      <Hero />

      <About />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-1 gap-6 px-6 mt-12">
        <div className="lg:col-span-1">
          <DeliveryTypes />
        </div>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-1 gap-6 px-6 mt-12">
        <div className="lg:col-span-1">
          <ServiceTypes />
        </div>
      </div>
      <div>
        <h2 className="text-2xl font-semibold mb-6"> </h2>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-1 gap-6 px-6 mt-12">
        <div className="lg:col-span-1">
          <Expertise />
        </div>
      </div>

      <br />
      {/* <Contact /> */}
      <Footer />
      {/* <WhatsAppButton /> */}
    </div>
  );

  return (
    <div
      className={darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"}
    >
      <button
        className="fixed top-4 right-4 z-50 p-2 bg-green-600 text-white rounded-full shadow-lg"
        onClick={() => setDarkMode(!darkMode)}
        aria-label="Toggle Dark Mode"
      >
        {darkMode ? "☀️" : "🌙"}
      </button>
      <Hero />
      <About />
      <Products />
      <Contact />
      <Footer />
      {/* <WhatsAppButton /> */}
    </div>
  );
}
